"use client";

import { AppErrorScreen } from "@/components/system/AppErrorScreen";

/**
 * Error boundary de toda la app (menos el layout raíz, que lo cubre
 * `global-error.tsx`).
 *
 * Antes no existía: una excepción de cliente mostraba el "Application error"
 * pelado de Next y el reporte que llegaba era "se me rompió", sin nada más.
 * `reset()` re-renderiza el segmento, así que un error transitorio se arregla
 * sin recargar.
 */
export default function AppError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return <AppErrorScreen error={error} reset={reset} />;
}
